<mat-dialog-content class="modal-header">
  <h2 mat-dialog-title>RENOVAR DOCUMENTO</h2>
</mat-dialog-content>

<form #modelForm="ngForm" (ngSubmit)="onSubmit(modelForm, fileUpload.files)" appIdentityRevealed>


<mat-dialog-content class="modal-body">
  <div class="content">
    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <label class="col-md-2 control-label">Fecha:</label>
          <div class="col-md-9">
            <mat-form-field appearance="outline">
              <mat-label>Fecha de Vencimiento</mat-label>
              <input 
                matInput
                [min]="model.fechaVencimiento"                
                [matDatepicker]="pckrFechaVencimiento"
                [(ngModel)]="model.fechaVencimiento"
                [value]="model.fechaVencimiento"
                name="fechaVencimiento"
                disabled
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="pckrFechaVencimiento"
              ></mat-datepicker-toggle>
              <mat-datepicker #pckrFechaVencimiento  disabled="false"></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-2 control-label">Archivo:</label>
          <div class="col-md-9">
            <input
              type="file"
              class="file-input"
              required
              #fileUpload
            />
            <!-- 
              (change)="uploadFile(fileUpload.files)"
              style="display: none;" -->
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-3 control-label">Comentarios:</label>
        </div>

        <div class="form-group">
          
          <div class="col-md-11">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Comentarios</mat-label>
              <textarea
                matInput
                placeholder="Comentarios"
                [(ngModel)]="model.comentarios"
                name="comentarios"
                rows="5" [maxlength]="2000"
              ></textarea>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-actions">
  <button type="submit" class="btn btn-naranja" mat-button >
    <mat-icon>save</mat-icon> Guardar
  </button>
  <!-- [mat-dialog-close]="data" -->
  <!-- <button class="btn btn-rojo2" mat-button [mat-dialog-close]="data" (click)="observar()">Observar</button> -->
  <button type="button" class="btn btn-naranja2" mat-button (click)="onNoClick()">
    <mat-icon>exit_to_app</mat-icon> Cancelar
  </button>
</mat-dialog-actions>

</form>